const OnboardingStep = ({ image, altText, description }) => {
  return (
    <div className="carousel-item active">
      <img src={image} alt={altText} />
      <p className="onboarding-text">{description}</p>
    </div>
  );
};

export default OnboardingStep;
